import { FormControl, StepContent, TextField } from '@mui/material';
import { FormStepProps, ValueByStep } from '@pages/SavingsCalculator/types';
import NumericFormatCustom from '../NumericInput/NumericInput';

const VolumeStep = ({ values, setStepValue }: FormStepProps) => {
  const handleVolumeChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setStepValue({
      newStep: ValueByStep.volume + 1,
      value: e.target.value,
    });
  };
  return (
    <StepContent>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <TextField
          value={values.step1}
          onChange={handleVolumeChange}
          placeholder="10000"
          InputProps={{
            inputComponent: NumericFormatCustom as any,
          }}
        />
      </FormControl>
    </StepContent>
  );
};

export default VolumeStep;
